export const DEFAULT_ORDER_BY_PARAM = 'relevance';

export const PAGE_SIZE = '34';

export enum CONTENT_TYPES {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  CAROUSEL_ALBUM = 'CAROUSEL_ALBUM',
}

export enum INSTAGRAM_PRODUCT_TYPES {
  FEED = 'FEED',
  STORY = 'STORY',
  REELS = 'REELS',
}

export enum YOUTUBE_CONTENT_PRIVACY_STATUS {
  PUBLIC = 'public',
  PRIVATE = 'private',
  NOT_LISTED = 'not listed',
}

export enum YOUTUBE_ASSET_SIZE {
  default = 'default',
  high = 'high',
  max = 'maxres',
  medium = 'medium',
  standard = 'standard',
}
